import React, { useState } from 'react';
import RegionSelect from '../../../components/RegionSelect';
import CountrySelect from '../../../components/CountrySelect';
import SupplierFilter from '../../../components/SupplierFilter/SupplierFilter';
import CriticalSupplierFilter from '../../../components/SupplierFilter/CriticalSupplierFilter';
import { AddCircle } from '@material-ui/icons';
import { IconButton, Chip, Fade, Radio, RadioGroup, FormControlLabel, Tooltip, Button, makeStyles } from '@material-ui/core';
import OutlinedDiv from '../../../components/UI/OutlinedDiv';
import { AttachFile } from '@material-ui/icons';
import { NOTIFICATION } from '../../../constants/GlobalConstants';
import TreasuryGroupsSelect from '../../../components/TreasuryGroupsSelect';
import { separations } from '../../../constants/StyleConstants';

const useStyles = makeStyles(theme => ({
  radioButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 1em 0 1em',
    columnGap: '1em',
    '& div[role="radiogroup"]': {
      flexDirection: 'row !important',
    },
  },
  ...separations,
}));

const addToTheList = (list, setNewList, newValue, setNewValue) => {
  !list.includes(newValue) && setNewList([...list, newValue]);
  setNewValue(null);
};

const deleteElementFromList = (list, element) => list.filter(s => s !== element);

const MultiSelect = ({ classes, list, label, labelChip, deleteChip, value, addList, children, readOnly }) => {
  return (
    <div className={classes.supplierPicker}>
      {!list.isEmpty() && (
        <Fade in={true}>
          <div className={classes.chipsWrapper}>
            <OutlinedDiv label={label}>
              {list.map(element => (
                <Chip
                  className={classes.chip}
                  size="small"
                  label={element[labelChip]}
                  onDelete={!readOnly ? () => deleteChip(element) : undefined}
                  color="primary"
                />
              ))}
            </OutlinedDiv>
          </div>
        </Fade>
      )}
      <div className={classes.middleAlignment}>
        {children}
        {!readOnly && (
          <IconButton className={classes.addReceiverBtn} disabled={!value} color="primary" aria-label="addReceiver" onClick={addList}>
            <AddCircle fontSize="large" />
          </IconButton>
        )}
      </div>
    </div>
  );
};

export const SupplierMultiSelect = ({ classes, selectedItems, setSelectedItems, readOnly }) => {
  const [value, setValue] = useState(null);

  return (
    <MultiSelect
      classes={classes}
      list={selectedItems}
      label="Proveedores seleccionados"
      labelChip="businessName"
      deleteChip={supplier => setSelectedItems(deleteElementFromList(selectedItems, supplier))}
      value={value}
      setValue={setValue}
      addList={() => addToTheList(selectedItems, setSelectedItems, value, setValue)}
      readOnly={readOnly}>
      {!readOnly && <SupplierFilter value={value} setValue={setValue} />}
    </MultiSelect>
  );
};

export const CriticalSuppliersMultiSelect = ({ classes, selectedItems, setSelectedItems, readOnly }) => {
  const [value, setValue] = useState(null);

  return (
    <MultiSelect
      classes={classes}
      list={selectedItems}
      label="Proveedores criticos seleccionados"
      labelChip="businessName"
      deleteChip={supplier => setSelectedItems(deleteElementFromList(selectedItems, supplier))}
      value={value}
      setValue={setValue}
      addList={() => addToTheList(selectedItems, setSelectedItems, value, setValue)}
      readOnly={readOnly}>
      {!readOnly && <CriticalSupplierFilter value={value} setValue={setValue} />}
    </MultiSelect>
  );
};

export const RegionMultiSelect = ({ classes, selectedItems, setSelectedItems, readOnly }) => {
  const [value, setValue] = useState('');

  return (
    <MultiSelect
      classes={classes}
      list={selectedItems}
      label="Regiones seleccionados"
      labelChip="name"
      deleteChip={region => setSelectedItems(deleteElementFromList(selectedItems, region))}
      value={value}
      setValue={setValue}
      addList={() => addToTheList(selectedItems, setSelectedItems, value, setValue)}
      readOnly={readOnly}>
      {!readOnly && <RegionSelect style={{ marginBottom: 8 }} value={value} setValue={setValue} />}
    </MultiSelect>
  );
};

export const CountryMultiSelect = ({ classes, selectedItems, setSelectedItems, readOnly }) => {
  const [value, setValue] = useState('');

  return (
    <MultiSelect
      classes={classes}
      list={selectedItems}
      label="Paises seleccionados"
      labelChip="name"
      deleteChip={country => setSelectedItems(deleteElementFromList(selectedItems, country))}
      value={value}
      setValue={setValue}
      addList={() => addToTheList(selectedItems, setSelectedItems, value, setValue)}
      readOnly={readOnly}>
      {!readOnly && <CountrySelect style={{ marginBottom: 8 }} value={value} setValue={setValue} />}
    </MultiSelect>
  );
};

export const TreasuryGroupsMultiSelect = ({ classes, selectedItems, setSelectedItems, readOnly }) => {
  const [value, setValue] = useState('');

  return (
    <MultiSelect
      classes={classes}
      list={selectedItems}
      label="Grupos de tesorería seleccionados"
      labelChip="name"
      deleteChip={treasuryGroup => setSelectedItems(deleteElementFromList(selectedItems, treasuryGroup))}
      value={value}
      setValue={setValue}
      addList={() => addToTheList(selectedItems, setSelectedItems, value, setValue)}
      readOnly={readOnly}>
      {!readOnly && <TreasuryGroupsSelect style={{ marginBottom: 8 }} value={value} setValue={setValue} />}
    </MultiSelect>
  );
};

export const SendToRadioButtons = ({ groupType, onChange, readOnly }) => {
  const classes = useStyles();

  const options = [
    { value: NOTIFICATION.SUPPLIER.GROUP_TYPE, label: NOTIFICATION.SUPPLIER.DESCRIPTION },
    { value: NOTIFICATION.CRITICAL_SUPPLIER.GROUP_TYPE, label: NOTIFICATION.CRITICAL_SUPPLIER.DESCRIPTION },
    { value: NOTIFICATION.ALL_SUPPLIER.GROUP_TYPE, label: NOTIFICATION.ALL_SUPPLIER.DESCRIPTION },
    { value: NOTIFICATION.TREASURY_GROUPS.GROUP_TYPE, label: NOTIFICATION.TREASURY_GROUPS.DESCRIPTION },
    { value: NOTIFICATION.REGION.GROUP_TYPE, label: NOTIFICATION.REGION.DESCRIPTION },
    { value: NOTIFICATION.COUNTRY.GROUP_TYPE, label: NOTIFICATION.COUNTRY.DESCRIPTION },
  ];

  return (
    <div className={classes.topSeparation}>
      <OutlinedDiv label="Enviar a:">
        <div className={classes.radioButtonContainer}>
          <RadioGroup aria-label="receivers" name="receivers" value={groupType} onChange={onChange}>
            {options.map(radio => (
              <FormControlLabel
                value={radio.value}
                control={<Radio inputProps={{ disabled: readOnly }} color="primary" />}
                label={radio.label}
              />
            ))}
          </RadioGroup>
        </div>
      </OutlinedDiv>
    </div>
  );
};

export const AttachmentContainer = ({ classes, attachedFiles, setAttachedFiles, setDropZoneTransIn }) => {
  const handleAttachment = () => {
    setDropZoneTransIn(true);
  };

  const deleteAttachment = attachment => {
    setAttachedFiles(attachedFiles.filter(file => file.name !== attachment.name));
  };
  return (
    <>
      <div className={classes.topSeparation}>
        {!attachedFiles.isEmpty() && (
          <Fade in={true}>
            <div className={classes.chipsWrapper}>
              <OutlinedDiv label="Archivos adjuntos">
                {attachedFiles.map(att => (
                  <Chip className={classes.chip} size="small" label={att.name} onDelete={() => deleteAttachment(att)} color="primary" />
                ))}
              </OutlinedDiv>
            </div>
          </Fade>
        )}
      </div>
      {attachedFiles.length < 5 && (
        <div className={classes.topSeparation}>
          <Tooltip title={'Adjuntar archivo'} enterDelay={1000}>
            <Button variant="contained" color="primary" startIcon={<AttachFile />} onClick={handleAttachment}>
              Adjuntar archivo
            </Button>
          </Tooltip>
        </div>
      )}
    </>
  );
};
